import styled, { css } from 'styled-components';

import { TextButton as TextButtonComponent } from '@xing-com/button';
import { Flag as FlagComponent } from '@xing-com/flag';
import { mediaSmallOrTiny, mediaWideNavless } from '@xing-com/layout-tokens';
import {
  scale080,
  scale110,
  space4XL,
  space6XL,
  spaceL,
  spaceS,
  spaceXXL,
  xdlColorTextSecondary,
} from '@xing-com/tokens';
import {
  BodyCopy as BodyCopyComponent,
  Hero as HeroComponent,
} from '@xing-com/typography';

export const PageInfoContainer = styled.header<{ $isLoggedIn: boolean }>`
  margin: ${spaceL} 0
    ${({ $isLoggedIn }) => ($isLoggedIn ? space6XL : spaceXXL)};

  @media ${mediaWideNavless} {
    margin: ${space4XL} 0 ${space6XL};
  }

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${spaceXXL};
  }
`;

export const Hero = styled(HeroComponent)`
  padding: 0 0 ${spaceS};

  @media ${mediaSmallOrTiny} {
    font-size: ${scale110};
  }
`;

export const BodyCopy = styled(BodyCopyComponent)`
  color: ${xdlColorTextSecondary};
  max-width: 750px;
  margin: 0;
  width: 100%;

  @media ${mediaSmallOrTiny} {
    font-size: ${scale080};
  }
`;

export const TextButton = styled(TextButtonComponent)`
  margin-top: ${spaceS};
`;

export const TitleWrapper = styled.span<{ $isPremium?: boolean }>`
  ${({ $isPremium }) =>
    $isPremium &&
    css`
      &::after {
        content: '\\A0';
      }
    `}
`;

export const Flag = styled(FlagComponent)`
  vertical-align: middle;
`;
